<template>

    <div>
        <form>
            <div v-for="child in children">
                <div class="form-group row">
                    <label :for="'sel'+child"
                        class="col-sm-3 col-form-label">{{child}}. {{voMsg('quote.child')}}</label>
                    <div class="col-sm-9 align-self-center">
                        <select :id="'sel'+child"
                            :name="'sel'+child"
                            v-model="childrenModel[child]"
                            @change="onChange($event)"
                            class="form-control">
                            <option value="undefined"
                                selected>{{voMsg('quote.unknownage')}}</option>

                            <option v-for="a in ages"
                                :value="a">
                                <span v-if="a == 0">{{a}} {{voMsg('quote.years')}}</span>
                                <span v-if="a == 1">{{a}} {{voMsg('quote.year')}}</span>
                                <span v-if="a > 1">{{a}} {{voMsg('quote.years')}}</span>
                            </option>
                        </select>
                    </div>
                </div>
            </div>
        </form>
    </div>



</template>
<script>
    import V from 'voUtils/V.js';

    export default {
    	name: 'childrenage',
    	voVueComponent: 'childrenage',
    	data() {
    		return {
    			childrenModel: []
    		}
    	},
    	props: {
    		children: Number,
    		callback: Function
    	},
    	computed: {
    		ages: function() {
    			var ages = [];
    			for (var i = 1; i <= 17; i++) {
    				ages.push(i);
    			}
    			return ages;
    		}
    	},
    	methods: {

    		onChange(event) {

    			let childrenArray = this.childrenModel;
    			let count = 0
    			let childrenAgesArray = [];
    			let childrenAgesString = '';
    			let youngestChild;
    			let minAge = 0;
    			let el = document.querySelector("[data-unit-minage]");
    			if (el) {
    				minAge = el.getAttribute('data-unit-minage') ? el.getAttribute('data-unit-minage') : 0;
    			}

    			//console.log('Minage::', minAge);

    			for (let i = 0; i < childrenArray.length; i++) {
    				if (parseInt(childrenArray[i]) >= 0) {
    					//console.log('ArrayValue::', childrenArray[i]);
    					childrenAgesArray.push(childrenArray[i]);
    					count++;
    				}
    			}

    			if (childrenAgesArray.length > 0) {
    				youngestChild = Math.min.apply(null, childrenAgesArray);
    			}

    			//console.log('youngestChild', youngestChild);


    			if (count === this.children) {
    				childrenAgesString = childrenAgesArray.toString();
    				this.callback(childrenAgesString);
    				document.querySelectorAll(".children-age-notice").forEach(e => e.style.display = 'none');

    			} else {
    				this.callback(undefined);
    				document.querySelectorAll(".children-age-notice").forEach(e => e.style.display = 'block');
    			}

    			if (count === this.children && (youngestChild < minAge)) {
    				document.querySelectorAll(".booknowbutton").forEach(e => e.disabled = true);
    			} else if (count === this.children && (youngestChild >= minAge)) {
    				document.querySelectorAll(".booknowbutton").forEach(e => e.disabled = false);
    			}


    		},
    	},
    	watch: {
    		children: function(newVal, oldVal) {
    			//console.log('Prop changed: ', newVal, ' | was: ', oldVal)
    			this.childrenModel = [];

    		}
    	}
    }
</script>